<script lang="ts">
	import Box from '../Box.svelte';
	import type { BoxHighlightContent } from '../types';
	import { attrValue } from '$lib/utils/html';
	import ButtonArrowWhite from '../../../elements/buttons/variants/ButtonArrowWhite.svelte';

	export let props: BoxHighlightContent;
</script>

<Box
	props={{
		...props,
		color: 'real-estate',
		classNames: attrValue([props.classNames, 'space-y-4 p-3 md:p-4 lg:p-5 overflow-hidden'])
	}}
>
	<h3 class="font-semibold">{props.content}</h3>
	{#if props.cta && props.ctaLabel}
		<ButtonArrowWhite
			props={{
				label: props.ctaLabel,
				href: props.cta,
				arrowColor: 'real-estate',
				classNames:
					'relative justify-between line-middle-right--inside line-middle-right--inside--white',
				hrefTarget: props.targetBlank ? 'blank' : '',
				iconClassNames: 'ml-0 md:ml-3 lg:ml-4'
			}}
		/>
	{/if}
</Box>
